import type { KeyboardEvent } from "react";

/**
 * Runs `commit` when Enter is pressed in a search field, and stops the keypress
 * there.
 *
 * Enter in a `type="search"` input inside a `<form>` triggers implicit
 * submission, which resets the field and discards the query, and the keypress
 * also reaches any `onKeyDown` on the form itself. IME users press Enter to
 * accept a composition candidate, which must not count as committing a search.
 *
 * @returns an `onKeyDown` handler for the input.
 */
export function commitSearchOnEnter(
  commit: () => void,
): (event: KeyboardEvent) => void {
  return (event) => {
    if (event.key !== "Enter") return;
    if (event.nativeEvent.isComposing) return;
    event.preventDefault();
    event.stopPropagation();
    commit();
  };
}
